export default "__VITE_ASSET__d62e1c45__"